import * as React from "react";
import { Card, Text, makeStyles, tokens } from "@fluentui/react-components";
import { DiscussionTypeOption } from "../types/discussionTypes";
import { useTypographyStyles } from "../../../styles/typography.styles";

const useStyles = makeStyles({
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: tokens.spacingHorizontalM,
    marginBottom: tokens.spacingVerticalL,
  },
  card: {
    padding: tokens.spacingVerticalL,
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: tokens.spacingVerticalS,
    border: `2px solid transparent`,
    transition: "all 0.2s ease",
    ":hover": {
      boxShadow: tokens.shadow8,
      transform: "translateY(-2px)",
    },
  },
  cardSelected: {
    border: `2px solid ${tokens.colorBrandBackground}`,
    backgroundColor: tokens.colorBrandBackground2,
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "48px",
    height: "48px",
    borderRadius: tokens.borderRadiusCircular,
  },
  title: {
    fontWeight: tokens.fontWeightSemibold,
  },
});

interface DiscussionTypeSelectorProps {
  title: string;
  types: DiscussionTypeOption[];
  selectedType: string | null;
  onTypeSelect: (typeId: string) => void;
}

const DiscussionTypeSelector: React.FC<DiscussionTypeSelectorProps> = ({
  title,
  types,
  selectedType,
  onTypeSelect,
}) => {
  const styles = useStyles();
  const typography = useTypographyStyles();

  return (
    <div>
      <Text className={typography.sectionTitle} style={{ marginBottom: tokens.spacingVerticalM, display: "block" }}>
        {title}
      </Text>
      <div className={styles.container}>
        {types.map((type) => {
          const Icon = type.icon;
          const isSelected = selectedType === type.id;

          return (
            <Card
              key={type.id}
              className={`${styles.card} ${isSelected ? styles.cardSelected : ""}`}
              onClick={() => onTypeSelect(type.id)}
            >
              <div
                className={styles.iconContainer}
                style={{ backgroundColor: `${type.color}20`, color: type.color }}
              >
                <Icon />
              </div>
              <Text className={styles.title}>{type.name}</Text>
              <Text className={typography.caption}>{type.description}</Text>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default DiscussionTypeSelector;
